<template>
	<v-card class="w-100 rounded-1 elevation-1 cta-card w-100">
		<div class="w-100 flex-center cta-card-content">
			<v-row class="w-100">
				<v-col class="flex-start flex-column pa-md-15 pa-10" lg="7" sm="12" cols="12">
					<h2 class="w-100 text-high-emphasis font-weight-regular text-md-h3 text-h4 text-left mb-3">
						Sign Up Now!
					</h2>
					<p class="w-100 text-medium-emphasis font-weight-light text-left">
						Browse an offering of various AI marketing tools personalized to your business needs.
					</p>

					<v-row class="w-100 my-5">
						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-0">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>
							Free Business Plan
						</v-col>

						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-0">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>
							AI Consultant
						</v-col>
						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-0">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>
							100+ AI Tools
						</v-col>
						<v-col cols="12" md="6" class="d-flex align-center justify-start pb-0">
							<v-icon class="mr-2" color="success" size="large">mdi-check</v-icon>
							Fast Customer Support
						</v-col>
					</v-row>

					<v-btn
						size="large"
						variant="outlined"
						class="mt-4 normal-spacing w-smm-100"
						width="220"
						:href="`${ctaLink}/register`">
						Create an Account
					</v-btn>
				</v-col>
				<v-col class="flex-center align-self-end h-100 flex-column pa-8" lg="5" sm="12" cols="12">
					<img src="../../assets/astro.png" alt="Handshake" style="max-height: 340px" />
				</v-col>
			</v-row>
		</div>

		<div class="w-100 cta-card-overlay"></div>
	</v-card>
</template>

<script>
	export default {
		name: "CtaCardTwo",
		props: {
			ctaLink: {
				type: String,
				required: true,
			},
		},
	}
</script>
